module.exports = __webpack_public_path__ + "static/media/kid2.241c73f1.jpg";